// Note bodies, keyed by their path in src/routes.json. The route entry holds
// the title, date, summary and preview card; this holds the words.
//
// To add a note: an entry in routes.json with "component": "Note", a body
// component here, rewrites in render.yaml, then `npm run og` for its card.

import type React from "react";
import SalesVsDeposits from "./SalesVsDeposits";
import type { NoteBodyProps } from "../types";

export const NOTE_BODIES: Readonly<Record<string, React.ComponentType<NoteBodyProps>>> = Object.freeze({
  "/notes/sales-vs-deposits": SalesVsDeposits,
});
